
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_xoje_103",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_xoje_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_xoje_125",
  "icon": "awsui_icon_gwq0h_xoje_139",
  "root": "awsui_root_gwq0h_xoje_157",
  "expand-button": "awsui_expand-button_gwq0h_xoje_195",
  "expanded": "awsui_expanded_gwq0h_xoje_202",
  "icon-container": "awsui_icon-container_gwq0h_xoje_212",
  "icon-container-container": "awsui_icon-container-container_gwq0h_xoje_216",
  "wrapper": "awsui_wrapper_gwq0h_xoje_220",
  "wrapper-default": "awsui_wrapper-default_gwq0h_xoje_228",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_xoje_228",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_xoje_232",
  "wrapper-container": "awsui_wrapper-container_gwq0h_xoje_235",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_xoje_239",
  "header-deprecated": "awsui_header-deprecated_gwq0h_xoje_252",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_xoje_274",
  "header": "awsui_header_gwq0h_xoje_252",
  "header-wrapper": "awsui_header-wrapper_gwq0h_xoje_294",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_xoje_306",
  "header-button": "awsui_header-button_gwq0h_xoje_311",
  "header-container-button": "awsui_header-container-button_gwq0h_xoje_311",
  "header-container": "awsui_header-container_gwq0h_xoje_311",
  "header-navigation": "awsui_header-navigation_gwq0h_xoje_346",
  "header-text": "awsui_header-text_gwq0h_xoje_383",
  "content": "awsui_content_gwq0h_xoje_103",
  "content-default": "awsui_content-default_gwq0h_xoje_390",
  "content-footer": "awsui_content-footer_gwq0h_xoje_394",
  "content-expanded": "awsui_content-expanded_gwq0h_xoje_398",
  "content-compact": "awsui_content-compact_gwq0h_xoje_401",
  "focusable": "awsui_focusable_gwq0h_xoje_405",
  "click-target": "awsui_click-target_gwq0h_xoje_420"
};
  